import(/* webpackMode: "eager" */ "/project/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/project/packages/client/src/components/OnboardingPopup.tsx");
;
import(/* webpackMode: "eager" */ "/project/packages/client/src/styles/globals.css");
